
import { HqPackingListDetail, PackCustomsPackingInput, ProductInfo, TableRowData } from "@/model/HqPackingListModels";
import {ProductInfoByPack} from "@/views/warehouse-management/HenganLoadingPlanDetailForWarehouse.vue";
import { Component, Vue } from "vue-property-decorator";
import { getHqPackingListPackages, writeHqPackingListPackage } from "@/api/hq-packing-list";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import {
  getCustomsGroups,
  markException,
  queryPackingExceptionReason,
  unmarkException,
  unpack
} from "@/api/customs-packing";
import { Form } from "element-ui";
import PackingListPackingDetail from "@/views/components/PackingListPackingDetail.vue";
import { CustomsPackingModel } from "@/model/HenganLoadingPlanModels";
import { cloneDeep, uniq } from "lodash";
import Template from "@/views/system-management/template/index.vue";
import { postContainerNumber,putContainerNumber } from "@/api/customs-packing"

@Component({
  name: "HqPackingListPackageManagement",
  components: {Template, PackingListPackingDetail, HqPackingListProductList }
})

export default class extends Vue {
  private exceptionReasons = [];
  private packingListKey = 0;
  private hqPackingListId: string;
  private hqPackingListDetail: HqPackingListDetail = null;
  private requireSelection = true;
  private dialogFormVisible = false;
  private payload = new PackCustomsPackingInput();
  private isInBulk = false;
  isLoading = false;

  private containerNumberList = [] as any;
  private editContainer = '';
  private containerNumberListEdit = [] as any;
  private showEditNumber = false;
  private selectionDataChild = [] as any;
  private selectionData = [] as any;

  private rules = {
    type: [{ required: true, message: "请选择包装类型", trigger: "blur" }],
    customsPackingCode: [{ required: true, message: "请输入主包装编号", trigger: "blur" }],
    grossWeight: [{ required: true, message: "请填写毛重（KG）", trigger: "blur" }],
    netWeight: [{ required: true, message: "请填写净重（KG）", trigger: "blur" }],
    length: [{ required: true, message: "请填写长（CM）", trigger: "blur" }],
    width: [{ required: true, message: "请填写宽（CM）", trigger: "blur" }],
    height: [{ required: true, message: "请填写高（CM）", trigger: "blur" }]
  };

  created() {
    this.hqPackingListId = this.$route.params.hqPackingListId;
    this.getList();
    this.getPackingReasons();
  }

  private async getPackingReasons() {
    const res:any = await queryPackingExceptionReason();
    this.exceptionReasons = res;
  }

  private async getList() {
    const details: any = await getHqPackingListPackages(this.hqPackingListId);
    this.hqPackingListDetail = details.hqPackingList;
  }

  private productSelectionChanged(rows: ProductInfo[]) {
    const productInfos : ProductInfoByPack[] = [];
    if (rows.length == 0) {
      this.payload.productInfos = productInfos;
      return;
    }
    rows.forEach((row) => {
    productInfos.push(new ProductInfoByPack(row.id,row.totalNumberPcs))
    });
    this.payload.productInfos = productInfos;
  }

  private selectionChanged(rows: TableRowData[],hqDetId) {
    console.log('rows',rows)
    // this.payload.customsPackingIds = rows.map(value => value.id);
    this.selectionData = rows.map(value => value.id);
    this.updateCustomsPackingIds()
  }
  private selectionChangedChild(ids: any, hqDetId){
    console.log('Child',ids)
    this.selectionDataChild = ids
    this.updateCustomsPackingIds()
  }
  private updateCustomsPackingIds(){
    this.payload.customsPackingIds =Array.from(new Set([...this.selectionDataChild,...this.selectionData ]));
    console.log('this.payload.customsPackingIds')
    console.log(this.payload.customsPackingIds)
  }

  private cancelDialog() {
    this.dialogFormVisible = false;
    this.payload = new PackCustomsPackingInput();
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async onDialogConfirmed() {
    await writeHqPackingListPackage(this.hqPackingListId, this.payload);
    this.cancelDialog();
    this.payload = new PackCustomsPackingInput();
    await this.getList();
    (this.$refs.hqPackingList as HqPackingListProductList).$forceUpdate();
    this.$message({
      message: "新建包装成功",
      type: "success",
      duration: 2000
    });
  }

  private async showDialog() {
    // let data = {
    //   ids: this.payload.customsPackingIds
    // }
    let data = uniq(this.payload.customsPackingIds);
    await postContainerNumber(data).then((res:any) => {
      this.containerNumberList = res;
      this.dialogFormVisible = true;
    }).catch(err => {
      console.log(err)
    })
  }

  private async editContainerNumber() {
    if(this.payload.customsPackingIds.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择需要修改的数据！",
        type: "warning",
        duration: 2000
      });
      return
    }
    let data = uniq(this.payload.customsPackingIds);
    await postContainerNumber(data).then((res:any) => {
      this.containerNumberListEdit = res;
      this.showEditNumber = true;
    }).catch(err => {
      console.log(err)
    })
  }

  private handleUnpack() {
    const msg = ['此操作将拆散主包装，是否拆？','强拆：子包装即使无重量和体积数据也能拆。','普拆：子包装无完整数据将不能拆。']
    const msgData = [];
    const h = this.$createElement;
    for (const i in msg) {
      msgData.push(h('p',null, msg[i]))
    }
    this.$confirm(
      '提示',
      {
        title: '拆托/箱',
        message: h('div', null, msgData),
        distinguishCancelAndClose: true,
        confirmButtonText: '普拆',
        cancelButtonText: '强拆'
      })
      .then(() => {
        this.doUnpack(false);
      })
      .catch(action => {
        if (action === 'close') {
          return;
        }
        this.doUnpack(true);
      })
  }

  private editNumberFlase() {
    this.showEditNumber = false;
    this.editContainer = '';
    this.containerNumberListEdit = [] as any;
  }

  private async editNumberTrue() {
    let data = {
      containerNumber: this.editContainer,
      customsPackingIds: uniq(this.payload.customsPackingIds)
    }
    await putContainerNumber(data).then(res => {
      this.$notify({
        title: "成功",
        message: "修改箱封号成功！",
        type: "success",
        duration: 2000
      });
      this.getList();
      this.showEditNumber = false;
    }).catch(err => {
      console.log(err)
    })
  }

  private async doUnpack(force: boolean) {
    if (this.payload.customsPackingIds.length === 0) {
      this.$message({
        message: "请选择要拆的包装",
        type: "error",
        duration: 2000
      });
      return;
    }
    // const customsPackingIds: string[] = this.payload.customsPackingIds.concat(uniq(
    //   this.customsPackingGroups.map(value => value.tableData).reduce((pre, cur) => pre.concat(cur), []).filter(value => value.select === true).map(value => value.id)));
    const customsPackingIdsSelect: string[] = uniq(
      this.customsPackingGroups.map(value => value.tableData).reduce((pre, cur) => pre.concat(cur), []).filter(value => value.select === true).map(value => value.id))
    const customsPackingIds: string[] = uniq([...this.payload.customsPackingIds,...customsPackingIdsSelect])
    console.log('customsPackingIds',customsPackingIds)


    // this.payload.customsPackingIds.map(e => {

    // })
    // console.log('this.payload.customsPackingIds',this.payload.customsPackingIds)
    // console.log('customsPackingGroups',this.customsPackingGroups)


    let inBulk = this.isInBulk;
    this.isLoading = true;
    await unpack(this.hqPackingListId, { customsPackingIds,inBulk, force })
    .finally(() => {
        this.isLoading = false;
    });
    await this.getList();

    this.payload.customsPackingIds = [];
    this.customsPackingGroups = [];
    this.currentPopoverTableData = [];
    this.$message({
      message: "拆托/箱成功",
      type: "success",
      duration: 2000
    });
  }

  private customsPackingGroups: CustomsPackingGroup[] = [];
  private currentSelectGroupId: string = null;
  private customsPackingSelectionDialogVisible = false;
  private currentPopoverTableData: GroupedCustomsPackingTableRowData[] = [];

  private async showGroupedCustomsPackingSelectionPopover(row) {
    this.$set(row, 'loading', true)
    try {
      this.currentSelectGroupId = null;
      this.currentPopoverTableData = [];
      if (row.groupId) {
        let group: CustomsPackingGroup = this.customsPackingGroups.filter(value => value.groupId === row.groupId)[0];
        if (!group) {
          const details: any = await getCustomsGroups(row.groupId);
          const data: GroupedCustomsPackingTableRowData[] = details.map(value => {
            const customsPacking: CustomsPackingModel = cloneDeep(value);
            return new GroupedCustomsPackingTableRowData(customsPacking);
          });
          group = new CustomsPackingGroup(row.groupId, data, true,row.id);
          this.customsPackingGroups.push(group);
        }
        // const rowSelected: boolean = this.payload.customsPackingIds.includes(row.id);
        // group.tableData.forEach(value => value.select = rowSelected);
        this.currentSelectGroupId = row.groupId;
        this.currentPopoverTableData = group.tableData;
        this.customsPackingSelectionDialogVisible = true;
        this.currentPopoverTableData.forEach((item)=>{
          if(this.selectionDataChild.includes(item.id)){
            item.select = true;
          }else{
            item.select = false;
          }
        })
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.$set(row, 'loading', false)
    }

  }

  private confirmGroupedCustomsPackingSelection() {
    const selected: boolean = this.customsPackingGroups.filter(value => value.groupId === this.currentSelectGroupId)[0].tableData.filter(value => value.select).length > 0;
    // const selected: boolean = this.customsPackingGroups.filter(value => value.groupId === this.currentSelectGroupId)[0].tableData.filter(value => value.select).length === this.customsPackingGroups.filter(value => value.groupId === this.currentSelectGroupId)[0].tableData.length;
    (this.$refs.hqPackingList as PackingListPackingDetail).toggleRowByGroupId(this.currentSelectGroupId, selected);
    const selectList = this.currentPopoverTableData.filter(res => res.select === true)
    console.log('selectList',selectList)
    this.customsPackingSelectionDialogVisible = false;
    (this.$refs.hqPackingList as PackingListPackingDetail).handleParentSelectionChildChange(this.currentPopoverTableData,this.currentSelectGroupId, selectList)
  }
  private cancelGroupedCustomsPackingSelection() {
    this.customsPackingSelectionDialogVisible = false;
  }

  private markExceptionLoading =  false;
  private showPackingInGroup = false;

  private async markException(row: any) {
    this.markExceptionLoading = true;
    try {
      await markException(row.id,row.exceptionReason);
      this.$set(row, 'popoverVisible', false);
      this.$set(row, 'exception', true);
      this.$set(row, 'exceptionReason', this.exceptionReasons.filter(value => value.name === row.exceptionReason)[0]);
      await this.getList();
      this.packingListKey++;
    }catch (err) {
      this.$message.error(err.message);
    }finally {
      this.markExceptionLoading = false;
    }
  }

  private async unmarkException(row: any) {
    try {
      await unmarkException(row.id);
      this.$set(row, 'popoverVisible', false)
      this.$set(row, 'exception', false);
      this.$set(row, 'exceptionReason', '');
      await this.getList();
    }catch (err) {
      console.error(err);
    }
  }

  private openAndClosePopover(row,open:boolean) {
    this.$set(row, 'popoverVisible', open);
  }
}

class CustomsPackingGroup {

  groupId: string;
  tableData: GroupedCustomsPackingTableRowData[] = [];
  popoverVisible: boolean;
  id: string;


  constructor(groupId: string, tableData: GroupedCustomsPackingTableRowData[], popoverVisible: boolean,id: string) {
    this.groupId = groupId;
    this.tableData = tableData;
    this.popoverVisible = popoverVisible;
    this.id = id;
  }
}

class GroupedCustomsPackingTableRowData extends CustomsPackingModel {

  select = false;

  constructor(customsPacking: CustomsPackingModel) {
    super();
    this.id = customsPacking.id;
    this.code = customsPacking.code;
    this.select = false;
    this.exception = customsPacking.exception;
    this.exceptionReason = customsPacking.exceptionReason;
    this.inventory = customsPacking.inventory;
  }
}

